/**
 * Имя шрифта для показа в списке — из имени файла без расширения.
 * "bebasneue.ttf" → "bebasneue".
 */
export function fontDisplayName(fileName: string): string {
  return fileName.trim().replace(/\.[^/.]+$/, '');
}
